import { Grid } from '@material-ui/core'
import { AttachFile } from '@material-ui/icons'
import PrintIcon from '@material-ui/icons/Visibility'
import { AttachmentDialog } from 'components/Dialog/AttachmentDialog'
import { useDocumentListingQuery } from 'generated/graphql'
import { AttachmentDetailView } from 'helpers/Hooks/attachmentDetailsView'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { default as React, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  docType?: string
  mode?: string
  itemQueryData?: string
  isSelfBilled?: boolean
}

export const APDetailExpansion = (props: DetailProps) => {
  const {
    listEl,
    documentListing,
    userList,
    docType,
    itemQueryData,
    isSelfBilled,
  } = props
  let history = useHistory()
  const { CompanyID }: any = useParams()

  let primaryKey
  switch (docType) {
    case 'advance':
      primaryKey = 'AdvanceID'
      break
    case 'invoice':
      primaryKey = 'InvoiceID'
      break
    case 'credit-note':
      primaryKey = 'CreditNoteID'
      break
    case 'creditor-credit-note':
      primaryKey = 'CreditorCreditNoteID'
      break
    case 'creditor-debit-note':
      primaryKey = 'CreditorDebitNoteID'
      break
    case 'debit-note':
      primaryKey = 'DebitNoteID'
      break
    case 'payment':
      primaryKey = 'PaymentID'
      break
    case 'refund':
      primaryKey = 'RefundID'
      break

    default:
      break
  }

  const {
    loading: documentLoading,
    data: { DocumentListing } = { DocumentListing: [] },
  } = useDocumentListingQuery({
    fetchPolicy: 'network-only',
    variables: {
      refID: listEl?.[`${primaryKey}`],
    },
  })

  const [openDoc, setOpenDoc] = useState<boolean>(false)
  const { menu } = useMenuOption()

  let trxType =
    listEl?.einvoice_trx_type === 'SELF_BILLED_CREDIT_NOTE'
      ? 'Credit Note'
      : listEl?.einvoice_trx_type === 'SELF_BILLED_REFUND_NOTE'
      ? 'Refund Note'
      : listEl?.einvoice_trx_type === 'SELF_BILLED_DEBIT_NOTE'
      ? 'Debit Note'
      : 'Invoice'

  return (
    <>
      {(docType === 'advance' ||
        docType === 'refund' ||
        docType === 'payment') && (
        <>
          <Grid container>
            <Grid item xs={10}>
              <div className="content-wrap full">
                <div className="desc">Creditor Name</div>
                <div className="xsTitle">
                  {listEl?.CreditorAccount?.CompanyName}
                </div>
              </div>
              <Grid container>
                <Grid item xs={6}>
                  <div>
                    <div className="desc">Reference No</div>
                    <div className="xsTitle text-noflow">{listEl?.RefNo}</div>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ placeSelf: 'end', textAlign: 'right' }}
                >
                  <div>
                    <div className="desc">{'Transaction Date'}</div>
                    <div
                      className="mdDesc text-noflow"
                      style={{ fontSize: '11px' }}
                    >
                      {formatDate(listEl?.TransactionDate)}
                    </div>
                  </div>
                </Grid>
              </Grid>

              <div className="content-wrap full">
                <div className="desc">Description</div>
                <div className="xsTitle text-noflow">{listEl?.Description}</div>
              </div>

              {listEl?.Remark && (
                <div className="content-wrap full">
                  <div className="desc">Remark</div>
                  <div className="xsTitle text-noflow">{listEl?.Remark}</div>
                </div>
              )}
            </Grid>
            <Grid item xs={2}>
              <span
                style={{ float: 'right' }}
                onClick={() => {
                  history.push({
                    pathname: `/account-payable/${CompanyID}/${docType}/${
                      listEl?.[`${primaryKey}`]
                    }/preview`,
                    state: {
                      ...listEl,
                      mode: 'detail',
                    },
                  })
                }}
              >
                <PrintIcon
                  style={{
                    fontSize: 'medium',
                    padding: '0px 10px 2px 0px',
                  }}
                />
              </span>
              {documentListing && documentListing?.length > 0 && (
                <>
                  <span
                    style={{ float: 'right', color: '#000' }}
                    onClick={() => {
                      setOpenDoc(true)
                    }}
                  >
                    <AttachFile
                      className="mdDesc"
                      style={{
                        fontSize: 12,
                        color: 'orange',
                      }}
                    />

                    <span
                      className="mdDesc"
                      style={{
                        float: 'right',
                        color: 'orange',
                        textDecoration: 'underline',
                        paddingRight: '5px',
                      }}
                    >
                      {documentListing?.length}
                    </span>
                  </span>
                </>
              )}
            </Grid>
          </Grid>

          <div className="content-wrap left">
            {docType === 'refund' ? (
              <div className="desc">Refund Method</div>
            ) : (
              <div className="desc">Payment Method</div>
            )}

            <div className="xsTitle">{listEl?.PaymentMethod?.Name}</div>
          </div>
          <div className="content-wrap full">
            <div className="desc">Bank Account No.</div>
            <div className="xsTitle" style={{ whiteSpace: 'break-spaces' }}>
              {`${listEl?.BankAccount?.AccountNo} (${listEl?.BankAccount?.BankProfile?.Name})`}
            </div>
          </div>

          {listEl?.PaymentMethod?.Name?.includes('Card') && (
            <div className="content-wrap right">
              <div className="desc">Card Type</div>
              <div className="xsTitle">{listEl?.CreditCardType?.Name}</div>
            </div>
          )}

          {listEl?.PaymentMethod?.Name === 'Cheque' && (
            <div className="content-wrap right">
              <div className="desc">Cheque No.</div>
              <div className="xsTitle">{listEl?.ChequeNo}</div>
            </div>
          )}

          {listEl?.PaymentMethod?.Name === 'Cheque' && (
            <div className="content-wrap left">
              <div className="desc">Cheque Date</div>
              <div className="xsTitle">{formatDate(listEl?.ChequeDate)}</div>
            </div>
          )}

          {listEl?.PaymentMethod?.Name === 'Cheque' && (
            <div className="content-wrap full">
              <div className="desc">Cheque Expiry Date</div>
              <div className="xsTitle">
                {formatDate(listEl?.ChequeExpiryDate)}
              </div>
            </div>
          )}
        </>
      )}

      {(docType === 'debit-note' ||
        docType === 'invoice' ||
        docType === 'creditor-credit-note' ||
        docType === 'credit-note' ||
        'self-billed') && (
        <>
          <Grid container>
            <Grid item xs={isSelfBilled ? 5 : 10}>
              <div className="content-wrap left">
                <div className="desc">Reference No.</div>
                <div className="xxTitle text-noflow">{listEl?.RefNo}</div>
              </div>
              {docType === 'invoice' && listEl?.DO?.length !== 0 && (
                <div className="content-wrap right ">
                  <div className="desc">DO No.</div>
                  <div className="xxTitle">
                    {' '}
                    {listEl?.DO?.map(x => x?.DocNo).join(', ') ?? ''}{' '}
                  </div>
                </div>
              )}

              {docType === 'creditor-credit-note' &&
                listEl?.GRTN?.length !== 0 && (
                  <div className="content-wrap right ">
                    <div className="desc">GRTN No.</div>
                    <div className="xxTitle">
                      {' '}
                      {listEl?.GRTN?.map(x => x?.DocNo).join(', ') ?? ''}{' '}
                    </div>
                  </div>
                )}

              <div className="content-wrap left">
                <div className="desc">{'Transaction Date'}</div>
                <div
                  className="xxTitle text-noflow"
                  style={{ fontSize: '11px' }}
                >
                  {formatDate(listEl?.TransactionDate)}
                </div>
              </div>

              {listEl?.DocRefNo?.length > 0 && (
                <div className="content-wrap full">
                  <div className="desc">Document Reference</div>
                  <div className="xsTitle text-noflow">
                    {listEl?.DocRefNo.join(', ')}
                  </div>
                </div>
              )}

              {listEl?.einvoice_self_billed_date && (
                <div className="content-wrap right">
                  <div className="desc">{'Self Billed Date'}</div>
                  <div
                    className="xxTitle text-noflow"
                    style={{ fontSize: '11px' }}
                  >
                    {formatDate(listEl?.DocDate)}
                  </div>
                </div>
              )}
              {listEl?.Description && (
                <>
                  <div className="content-wrap full">
                    <div className="desc">Description</div>
                    <div className="xxTitle text-noflow">
                      {listEl?.Description}
                    </div>
                  </div>
                </>
              )}
              {listEl?.Remark && (
                <div className="content-wrap full">
                  <div className="desc">Remark</div>
                  <div className="xxTitle text-noflow">{listEl?.Remark}</div>
                </div>
              )}
            </Grid>

            {isSelfBilled && (
              <Grid item xs={5}>
                {docType === 'self-billed' ? (
                  <div className="content-wrap full">
                    <div className="desc">Transaction Type</div>
                    <div className="xxTitle">{`Self-Billed ${trxType}`}</div>
                  </div>
                ) : null}
              </Grid>
            )}
            <Grid item xs={2}>
              {(docType === 'credit-note' || docType === 'debit-note') && (
                <>
                  <span
                    style={{ float: 'right' }}
                    onClick={() => {
                      history.push({
                        pathname: `/account-payable/${CompanyID}/${docType}/${
                          listEl?.[`${primaryKey}`]
                        }/preview`,
                        state: {
                          ...listEl,
                          mode: 'detail',
                        },
                      })
                    }}
                  >
                    <PrintIcon
                      style={{
                        fontSize: 'medium',
                        padding: '0px 10px 2px 0px',
                      }}
                    />
                  </span>
                  <br />
                </>
              )}
              {documentListing && documentListing?.length > 0 && (
                <>
                  <div style={{ float: 'right', alignSelf: 'end' }}>
                    {documentListing && (
                      <>
                        <span
                          onClick={() => {
                            setOpenDoc(true)
                          }}
                          style={{
                            position: 'relative',
                            top: '1px',
                          }}
                        >
                          <AttachFile
                            className="mdDesc"
                            style={{
                              fontSize: 12,
                              color: 'orange',
                            }}
                          />
                        </span>
                        <span
                          className="mdDesc"
                          style={{
                            color: 'orange',
                            textDecoration: 'underline',
                          }}
                        >
                          {documentListing?.length}
                        </span>
                      </>
                    )}
                  </div>
                </>
              )}
            </Grid>
            <Grid item xs={12}>
              {!!listEl?.MSICCode && isSelfBilled && (
                <div className="content-wrap full">
                  <div className="desc">MSIC Code</div>
                  <div className="xxTitle text-noflow">{`${listEl?.MSICCode?.msicCode} (${listEl?.MSICCode?.description})`}</div>
                </div>
              )}
            </Grid>
          </Grid>
        </>
      )}

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted Date'}
        </div>
        <div className="mdDesc text-noflow">
          {formatDate(listEl?.submittedTs)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          {'Submitted By'}
        </div>
        <div className="mdDesc text-noflow">
          {userList?.filter(user => user.ID == listEl?.submittedBy)[0]?.name}
        </div>
      </div>

      <AttachmentDialog
        title="Payment"
        menu={menu}
        openDoc={openDoc}
        setOpenDoc={setOpenDoc}
        AttachmentDetailView={AttachmentDetailView}
        DocumentListing={DocumentListing}
      />
    </>
  )
}
